import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "../lib/site";
import { useContent } from "../context/ContentContext";
import { imgUrl } from "../lib/api";

export default function Lines({ onSelect }) {
  const content = useContent();
  const intro = content.lines_intro;
  const lines = content.lines || [];

  return (
    <section id="lineas" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32" data-testid="lines-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-14 max-w-2xl"
      >
        <p className="font-mono mb-4 text-xs uppercase tracking-[0.3em] text-brand">
          {intro.overline}
        </p>
        <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-neutral-900 sm:text-3xl lg:text-4xl">
          {intro.title}
        </h2>
        <p className="mt-4 text-sm leading-relaxed text-neutral-500 sm:text-base">
          {intro.subtitle}
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {lines.map((line, i) => {
          const desc = content.line_descs?.[line.id] || line.description;
          return (
            <motion.button
              key={line.id}
              onClick={() => {
                onSelect(line.id);
                scrollToId("#catalogo");
              }}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.1, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              whileHover={{ y: -6 }}
              className="group relative overflow-hidden rounded-2xl border border-[#E8E4D9] bg-white p-6 text-left shadow-sm transition-shadow duration-300 hover:shadow-xl"
              style={{ borderTop: `3px solid ${line.color}` }}
              data-testid={`line-card-${line.id}`}
            >
              <div
                className="absolute -right-10 -top-10 h-32 w-32 rounded-full opacity-15 blur-3xl transition-opacity duration-500 group-hover:opacity-30"
                style={{ background: line.color }}
              />
              {line.banner && (
                <img
                  src={imgUrl(line.banner)}
                  alt={line.name}
                  loading="lazy"
                  className="mb-4 h-12 w-auto object-contain object-left"
                />
              )}
              <h3 className="font-display mt-2 text-xl font-bold text-neutral-900 sm:text-2xl">
                {line.name}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-neutral-500">{desc}</p>
              <span
                className="mt-6 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest"
                style={{ color: line.color }}
              >
                Ver productos
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </motion.button>
          );
        })}
      </div>
    </section>
  );
}
